import ModerationMainContent from './components/ModerationMainContent/ModerationMainContent';

export default ModerationMainContent;
